import React, { Component, type ReactElement } from 'react'
import type LeadershipDto from './LeadershipDto'
import ManagershipDialog from './ManagershipDialog'
import './style.css'

interface Props {
  leader: LeadershipDto
}

interface State {
  showDialog: boolean
}

class ManagershipCard extends Component<Props, State> {
  state = { showDialog: false }

  handlePlusClick = (): void => {
    this.setState({ showDialog: true })
  }

  handleClose = (): void => {
    this.setState({ showDialog: false })
  }

  render(): ReactElement {
    const { name, position, enPosition, profile, intro } = this.props.leader
    return (
      <>
        <div className='managershipCard'>
          <div className='managershipCard-profile'>
            <img alt='managership-profile-picture' src={profile} />
            <button className='managershipCard-plus mobile-only' onClick={this.handlePlusClick} />
          </div>
          <div className='managershipCard-info'>
            <p className='managershipCard-name'>{name}</p>
            <p className='managershipCard-position'>
              {position}
              {enPosition}
            </p>
            <p className='managershipCard-intro'>{intro}</p>
          </div>
        </div>
        <ManagershipDialog
          open={this.state.showDialog}
          onClose={this.handleClose}
          leader={{
            name: name ?? '',
            position: position ?? '',
            enPosition: enPosition ?? '',
            intro: intro ?? '',
            profile: profile ?? ''
          }}
        />
      </>
    )
  }
}

export default ManagershipCard
